"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuoteComparisonReportDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
class QuoteComparisonReportDto {
}
exports.QuoteComparisonReportDto = QuoteComparisonReportDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "opportunityactivityId ID",
        example: 35,
    }),
    (0, class_validator_1.IsInt)({ message: "opportunityactivityId must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "opportunityactivityId is required" }),
    tslib_1.__metadata("design:type", Number)
], QuoteComparisonReportDto.prototype, "opportunityActivityId", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "brokingSlipVersion ID",
        example: 35,
    }),
    (0, class_validator_1.IsInt)({ message: "brokingSlipVersion must be an integer" }),
    (0, class_validator_1.IsNotEmpty)({ message: "brokingSlipVersion is required" }),
    tslib_1.__metadata("design:type", Number)
], QuoteComparisonReportDto.prototype, "brokingSlipVersion", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "quoteEntry Ids",
        example: [35, 36],
    }),
    (0, class_validator_1.IsArray)({ message: "quoteEntry must be an array of integers" }),
    (0, class_validator_1.IsNotEmpty)({ message: "quoteEntry is required" }),
    (0, class_transformer_1.Type)(() => Number),
    tslib_1.__metadata("design:type", Array)
], QuoteComparisonReportDto.prototype, "quoteEntry", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if broking slip covers are included",
        example: true,
    }),
    (0, class_validator_1.IsBoolean)({ message: "brokingSlipCovers must be a boolean" }),
    (0, class_validator_1.IsNotEmpty)({ message: "brokingSlipCovers is required" }),
    tslib_1.__metadata("design:type", Boolean)
], QuoteComparisonReportDto.prototype, "brokingSlipCovers", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if RFP details covers are included",
        example: false,
    }),
    (0, class_validator_1.IsBoolean)({ message: "rfpDetailsCovers must be a boolean" }),
    (0, class_validator_1.IsNotEmpty)({ message: "rfpDetailsCovers is required" }),
    tslib_1.__metadata("design:type", Boolean)
], QuoteComparisonReportDto.prototype, "rfpDetailsCovers", void 0);
